import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProductsHero from "@/components/products/ProductsHero";
import ProductsGrid from "@/components/products/ProductsGrid";
import CustomizationCTASection from "@/components/products/CustomizationCTASection";
import CTASection from "@/components/shared/CTASection";
import PageSEO from "@/components/shared/PageSEO";
import Breadcrumbs from "@/components/shared/Breadcrumbs";

const Products = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Electric Vehicles & Micro Mobility Products"
        description="Browse SDC's complete range of electric vehicles, patrol carts, stair climbers, electric unicycles & scooters in Saudi Arabia. عربات كهربائية ومركبات دورية للبيع في السعودية. B2B & B2G fleet solutions."
        keywords="electric vehicles Saudi Arabia, عربات كهربائية, مركبات كهربائية السعودية, patrol carts KSA, electric scooter Saudi, industrial EV Saudi, micro mobility products, سكوتر كهربائي للبيع, electric unicycle KSA, stair climber Saudi Arabia, دراجات كهربائية, fleet vehicles B2B B2G"
      />
      <Navbar />
      <ProductsHero />
      <Breadcrumbs />
      <ProductsGrid />
      <CustomizationCTASection />
      <CTASection
        title="Ready to Transform Your Fleet?"
        description="Get in touch with our team to discuss your mobility needs and receive a customized quote."
        primaryButtonText="Request a Quote"
        primaryButtonLink="/contact"
        secondaryButtonText="View Services"
        secondaryButtonLink="/services"
      />
      <Footer />
    </div>
  );
};

export default Products;
